<template>
   <div id="static-page-wrapper">
      <div class="container">
         <!-- <section id="page-header">
            <h1 class="page-title">Datenschutzerklärung</h1>
            
         </section> -->

         <div class="content-wrapper">
            <aside class="sidebar-menu">
               <nav class="sticky-nav">
                  <a
                     v-for="section in sections"
                     :key="section.id"
                     :href="'#' + section.id"
                     class="nav-item"
                     :class="{ active: activeSection === section.id, alreadyRead: section.read }"
                     @click.prevent="scrollToSection(section.id)">
                     <!-- <inline-svg
                        class="tick-icon"
                        :class="{ hidden: !section.read }"
                        :src="activeSection === section.id ? require('@/assets/img/check_gray.svg') : require('@/assets/img/check_white.svg')"
                        width="16"
                        height="16" /> -->

                     {{ section.label }}
                  </a>
               </nav>
            </aside>

            <div class="page-content">
               <section class="privacy-section">
                  <h2>Allgemeine Geschäftsbedingungen GTS Global Travel Services GmbH</h2>

                  <h3 id="geltungsbereich">1 Geltungsbereich und Vertragsparteien</h3>
                  <p>
                     <strong>1.1</strong> Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für sämtliche Geschäftsbeziehungen zwischen der GTS Global Travel Services GmbH, Hamburg
                     (nachfolgend „GTS"), und ihren Vertragspartnern.
                  </p>
                  <p>
                     <strong>1.2</strong> Vertragspartner von GTS können ausschließlich Unternehmer im Sinne des 14 BGB sein, insbesondere Reiseagenturen, Reiseveranstalter, Online-Reiseportale
                     (OTAs), Plattformbetreiber, API-Kunden, White-Label-Partner sowie sonstige gewerbliche Wiederverkäufer oder Vermittler von Reiseleistungen (nachfolgend einheitlich
                     „Vertragspartner").
                  </p>
                  <p>
                     <strong>1.3</strong> Diese AGB gelten für alle von GTS angebotenen Leistungen, unabhängig davon, ob diese über ein Online-Portal, eine API-Schnittstelle, eine Internet Booking
                     Engine (IBE), eine White-Label-Lösung oder vergleichbare technische Anbindungen genutzt werden.
                  </p>
                  <p><strong>1.4</strong> Abweichende Geschäftsbedingungen des Vertragspartners finden keine Anwendung, es sei denn, GTS hat ihrer Geltung ausdrücklich schriftlich zugestimmt.</p>
                  <p><strong>1.5</strong> Individuelle Vereinbarungen (z. B. Agentur-, API- oder Rahmenverträge) haben Vorrang vor diesen AGB.</p>

                  <h3 id="begriffe">2 Begriffsbestimmungen</h3>
                  <p>
                     <strong>2.1</strong> Endkunde ist jede natürliche oder juristische Person, die Reiseleistungen in Anspruch nimmt oder in Anspruch nehmen will und Kunde des Vertragspartners ist.
                  </p>
                  <p>
                     <strong>2.2</strong> Leistungsträger ist der jeweilige Anbieter der Reiseleistung, insbesondere Fluggesellschaften, Hotels, Mietwagenunternehmen, Transfer- oder sonstige
                     Reisedienstleister.
                  </p>
                  <p><strong>2.3</strong> Pauschalreise ist eine Reise im Sinne §651a ff. BGB, die von einem Reiseveranstalter als Gesamtleistung angeboten wird.</p>
                  <p><strong>2.4</strong> Leistungsverhältnis ist das Vertragsverhältnis zwischen dem Endkunden (oder dem Vertragspartner in eigenem Namen) und dem jeweiligen Leistungsträger.</p>
                  <p><strong>2.5</strong> Plattform ist das von GTS betriebene technische System zur Anzeige, Buchung, Reservierung oder Weiterleitung von Reiseleistungen.</p>
                  <p><strong>2.6</strong> API-, IBE- oder White-Label-Lösungen sind technische Systeme oder Schnittstellen zur automatisierten Bereitstellung von Reiseleistungsdaten.</p>

                  <h3 id="vertragsgegenstand">3 Vertragsgegenstand</h3>
                  <p>
                     <strong>3.1</strong> GTS betreibt eine technische Buchungs- und Vermittlungsplattform, über die Vertragspartner Einzelleistungen (insbesondere Flugleistungen,
                     Unterkunftsleistungen, Mietwagen und Transfers) sowie Pauschalreisen von Drittreiseveranstaltern anzeigen, vermitteln oder buchen können.
                  </p>
                  <p>
                     <strong>3.2</strong> GTS erbringt keine eigenen Reiseleistungen und tritt weder als Reiseveranstalter noch als Verkäufer oder Anbieter der vermittelten Reiseleistungen auf. GTS
                     tritt bei der Vermittlung von Pauschalreisen ausschließlich als technischer Dienstleister und Vermittler auf. Veranstalter der Pauschalreise ist ausschließlich der jeweilige
                     Drittreiseveranstalter im Sinne der §651a ff. BGB.
                  </p>
                  <p>
                     <strong>3.3</strong> Der Vertrag über die jeweilige Reiseleistung kommt ausschließlich zwischen dem jeweiligen Leistungsträger und dem Endkunden bzw. – sofern der Vertragspartner
                     im eigenen Namen handelt – zwischen dem Vertragspartner und dem Leistungsträger zustande.
                  </p>
                  <p>
                     <strong>3.4</strong> Für das jeweilige Leistungsverhältnis gelten ausschließlich die Geschäfts- und Vertragsbedingungen des jeweiligen Leistungsträgers. GTS übernimmt keine
                     Garantie für die Durchführung, Qualität oder Verfügbarkeit der Reiseleistungen.
                  </p>
                  <p>
                     <strong>3.5</strong> Die vorstehenden Regelungen gelten unabhängig davon, ob die Leistungen über das Online-Portal, eine API-Schnittstelle, eine IBE oder eine White-Label-Lösung
                     genutzt werden.
                  </p>

                  <h3 id="rolle">4 Rolle von GTS</h3>
                  <p><strong>4.1</strong> GTS handelt ausschließlich als technischer Dienstleister und Vermittler zwischen Vertragspartnern und Leistungsträgern.</p>
                  <p>
                     <strong>4.2</strong> Zwischen GTS und Endkunden kommt zu keinem Zeitpunkt ein Vertragsverhältnis zustande, auch nicht im Wege eines Vertrages mit Schutzwirkung zugunsten Dritter.
                  </p>
                  <p>
                     <strong>4.3</strong> GTS übernimmt keine Verantwortung für die ordnungsgemäße Erbringung der Reiseleistungen, für Angaben, Zusagen oder Inhalte der Leistungsträger oder sonstiger
                     angebundener Dritter sowie für die Endkundenkommunikation des Vertragspartners.
                  </p>
                  <p>
                     <strong>4.4</strong> Der Vertragspartner bleibt in seinem Außenverhältnis zum Endkunden allein verantwortlich für die Einhaltung gesetzlicher Informations- und
                     Betreuungspflichten.
                  </p>
                  <p><strong>4.5</strong> Die Rolle von GTS als technischer Dienstleister und Vermittler gilt auch bei Nutzung von API-, IBE- oder White-Label-Lösungen uneingeschränkt.</p>
                  <p>
                     <strong>4.6</strong> GTS übernimmt keine Veranstalterpflichten im Sinne des Pauschalreiserechts und stellt insbesondere keinen Sicherungsschein aus. Sämtliche gesetzlichen
                     Informations-, Absicherungs- und Haftungspflichten gegenüber Endkunden obliegen ausschließlich dem jeweiligen Pauschalreiseveranstalter sowie dem Vertragspartner im Rahmen seiner
                     Vermittlungstätigkeit.
                  </p>
                  <p>
                     <strong>4.7</strong> Unabhängig von der vorstehenden Rollenverteilung kann GTS dem Vertragspartner im Einzelfall eine freiwillige zusätzliche Absicherung für bestimmte
                     Buchungskonstellationen anbieten. Diese Zusatzabsicherung erfolgt ohne Anerkennung einer gesetzlichen Verpflichtung, insbesondere ohne Begründung einer Reiseveranstalterstellung
                     oder einer Verpflichtung zur Ausstellung eines Sicherungsscheins nach den §651a ff. BGB. Ein Anspruch des Vertragspartners auf eine solche Zusatzabsicherung besteht nicht.
                  </p>

                  <h3 id="nutzung">5 Nutzung der Plattform, Zugang und Sicherheit</h3>
                  <p>
                     <strong>5.1</strong> Der Zugang zur Plattform erfolgt grundsätzlich mittels Zwei-Faktor-Authentifizierung (2FA) unter Verwendung eines Benutzernamens, Passworts und eines
                     zeitbasierten Sicherheits-Tokens.
                  </p>
                  <p><strong>5.2</strong> Der Vertragspartner ist verpflichtet, Zugangsdaten vertraulich zu behandeln.</p>
                  <p><strong>5.3</strong> Auf Wunsch des Vertragspartners kann die 2FA gegen schriftliche Verzichtserklärung deaktiviert werden.</p>
                  <p><strong>5.4</strong> In diesem Fall trägt der Vertragspartner das volle Risiko für Accountmissbrauch.</p>
                  <p><strong>5.5</strong> Alle über den Account ausgelösten Buchungen bleiben zahlungspflichtig.</p>
                  <p><strong>5.6</strong> GTS haftet für Schäden infolge unbefugter Zugriffe auf Nutzerkonten nur bei vorsätzlichem oder grob fahrlässigem Verhalten von GTS.</p>

                  <h3 id="api">6 API-, IBE- und White-Label-Nutzung sowie Nutzungsbeschränkungen</h3>
                  <p>
                     <strong>6.1</strong> GTS stellt dem Vertragspartner – abhängig von der vertraglichen Vereinbarung – Programmierschnittstellen (API), Internet Booking Engines (IBE) oder
                     White-Label-Lösungen zur Verfügung. Diese dienen ausschließlich der technischen Anbindung an die Systeme von GTS sowie der automatisierten Bereitstellung von Reiseleistungsdaten.
                  </p>
                  <p>
                     <strong>6.2</strong> Die über API-, IBE- oder White-Label-Lösungen bereitgestellten Inhalte, insbesondere Preise, Verfügbarkeiten, Tarifbedingungen und Leistungsbeschreibungen,
                     stammen von den jeweiligen Leistungsträgern oder angebundenen Drittanbietern. GTS übernimmt keine Gewähr für deren Richtigkeit, Vollständigkeit oder Aktualität.
                  </p>
                  <p>
                     <strong>6.3</strong> Der Vertragspartner ist allein verantwortlich für die technische Integration, Konfiguration und den laufenden Betrieb der angebundenen Systeme. Dies umfasst
                     insbesondere die korrekte Darstellung der Inhalte, die Preisgestaltung gegenüber Endkunden sowie die ordnungsgemäße Weiterleitung von Buchungs- und Zahlungsinformationen.
                  </p>
                  <p>
                     <strong>6.4</strong> Bei White-Label-Lösungen tritt der Vertragspartner ausschließlich unter eigener Firma, Marke oder Domain gegenüber Endkunden auf. GTS wird weder als Verkäufer
                     noch als Reiseveranstalter oder Reisevermittler im Außenverhältnis tätig.
                  </p>
                  <p>
                     <strong>6.5</strong> Der Vertragspartner ist verpflichtet, gegenüber Endkunden transparent darzustellen, wer Vertragspartner der jeweiligen Reiseleistung ist und welche
                     Allgemeinen Geschäftsbedingungen Anwendung finden.
                  </p>
                  <p>
                     <strong>6.6</strong> Der Vertragspartner stellt GTS von sämtlichen Ansprüchen Dritter frei, die aus der Nutzung der API-, IBE- oder White-Label-Lösungen resultieren, es sei denn,
                     diese beruhen auf vorsätzlichem oder grob fahrlässigem Verhalten von GTS.
                  </p>
                  <p>
                     <strong>6.7</strong> Die Nutzung der von GTS bereitgestellten API-, IBE- oder White-Label-Systeme ist ausschließlich zum Zwecke der konkreten Buchung oder Vermittlung von
                     Reiseleistungen zulässig.
                  </p>
                  <p><strong>6.8</strong> Unzulässig ist insbesondere die Nutzung der Systeme</p>
                  <ul>
                     <li>ausschließlich zu Anzeige-, Vergleichs-, Analyse- oder Testzwecken ohne konkrete Buchungsabsicht,</li>
                     <li>zur systematischen Abfrage von Preisen, Tarifen oder Verfügbarkeiten außerhalb des vertraglich vereinbarten Nutzungsumfangs,</li>
                     <li>
                        zur Umgehung von Tarif-, Buchungs-, Ticketing- oder Stornierungsbedingungen der jeweiligen Leistungsträger, insbesondere durch wiederholtes Buchen und anschließendes
                        Stornieren.
                     </li>
                  </ul>
                  <p>
                     <strong>6.9</strong> Der Vertragspartner ist verpflichtet, durch geeignete organisatorische und technische Maßnahmen sicherzustellen, dass ein Missbrauch der Systeme durch
                     Mitarbeiter, Dritte oder automatisierte Prozesse ausgeschlossen wird.
                  </p>
                  <p>
                     <strong>6.10</strong> GTS ist berechtigt, bei auffälligem Nutzungsverhalten, Überschreitung vereinbarter Abrufmengen oder bei begründetem Verdacht auf missbräuchliche Nutzung den
                     Zugang zur API, IBE, White-Label-Lösung oder Plattform ganz oder teilweise vorübergehend oder dauerhaft zu sperren. Zahlungs- und Haftungsverpflichtungen des Vertragspartners
                     bleiben hiervon unberührt.
                  </p>
                  <p>
                     <strong>6.11</strong> Sämtliche von GTS bereitgestellten Daten, Inhalte, Tarifinformationen und technischen Schnittstellen unterliegen dem Schutz geistigen Eigentums. Der
                     Vertragspartner erhält hieran ein Einfaches, nicht übertragbares und nicht unterlizenzierbares Nutzungsrecht, beschränkt auf die vertragsgemäße Nutzung.
                  </p>
                  <p>
                     <strong>6.12</strong> Eine Weitergabe, Vervielfältigung, Spiegelung oder sonstige Übertragung der Daten oder Inhalte in Systeme Dritter ist unzulässig, sofern dies nicht
                     ausdrücklich schriftlich mit GTS vereinbart wurde.
                  </p>
                  <p>
                     <strong>6.13</strong> Die Nutzung der API-, IBE- und White-Label-Systeme ist ausschließlich im vertraglich vereinbarten Umfang ("Fair-Use") zulässig; eine darüberhinausgehende
                     oder unverhältnismäßige Nutzung kann von GTS eingeschränkt oder untersagt werden.
                  </p>

                  <h3 id="buchung">7 Buchungsablauf und Vertragsschluss</h3>
                  <p><strong>7.1</strong> Buchungs- und Reservierungsaufträge werden vom Vertragspartner über die von GTS bereitgestellten Systeme an die jeweiligen Leistungsträger übermittelt.</p>
                  <p>
                     <strong>7.2</strong> Der Vertragspartner ist verpflichtet, alle Buchungsdaten vor Übermittlung sorgfältig zu prüfen und sicherzustellen, dass diese den Vereinbarungen mit dem
                     Endkunden entsprechen. Der Vertragspartner darf Buchungsaufträge nur übermitteln, wenn er zuvor seine kaufmännische Sorgfaltspflicht erfüllt und insbesondere sichergestellt hat,
                     dass die Zahlungsabwicklung gegenüber GTS ordnungsgemäß gewährleistet ist.
                  </p>
                  <p>
                     <strong>7.3</strong> Mit Übermittlung eines Buchungsauftrages beauftragt der Vertragspartner GTS mit der technischen Vermittlung des Vertragsschlusses zwischen Leistungsträger und
                     Endkunde bzw. Vertragspartner.
                  </p>
                  <p>
                     <strong>7.4</strong> Der Vertrag über die Reiseleistung kommt ausschließlich zwischen dem Leistungsträger und dem Endkunden bzw. Vertragspartner zustande. GTS wird nicht
                     Vertragspartei dieses Leistungsverhältnisses.
                  </p>
                  <p><strong>7.5</strong> Buchungsbestätigungen sind vom Vertragspartner unverzüglich auf Richtigkeit und Vollständigkeit zu prüfen. Abweichungen sind GTS unverzüglich mitzuteilen.</p>
                  <p>
                     <strong>7.6</strong> Für einzelne Reiseleistungen, insbesondere Flug- und Mietwagenleistungen, gelten ergänzend die jeweiligen Bedingungen der Leistungsträger, auf die der
                     Vertragspartner Endkunden ausdrücklich hinzuweisen hat.
                  </p>

                  <h3 id="zahlung">8 Zahlungsabwicklung, Inkasso und Abtretung</h3>
                  <p>
                     <strong>8.1</strong> Der Vertragspartner ist verpflichtet, sämtliche aus Buchungen resultierenden Entgelte fristgerecht zu zahlen, unabhängig davon, ob Zahlungen von Endkunden
                     bereits erfolgt sind. GTS ist als IATA-lizenzierter Flug-Consolidator berechtigt, Flugleistungen über Abrechnungsstellen wie BSP sowie über direkte Abrechnungsvereinbarungen mit
                     Fluggesellschaften abzuwickeln. Die Zahlungspflicht des Vertragspartners besteht unabhängig vom gewählten Abrechnungsweg und auch dann uneingeschränkt fort, wenn GTS gegenüber
                     Leistungsträgern oder Abrechnungsstellen ganz oder teilweise in Vorleistung tritt.
                  </p>
                  <p><strong>8.2</strong> GTS ist berechtigt, Zahlungen im eigenen Namen oder im Namen der Leistungsträger einzuziehen und an diese weiterzuleiten.</p>
                  <p>
                     <strong>8.3</strong> Soweit der Vertragspartner Forderungen gegenüber Endkunden erhebt, tritt er diese erfüllungshalber an GTS ab. GTS ist berechtigt, diese Abtretung
                     offenzulegen.
                  </p>
                  <p>
                     <strong>8.4</strong> Sofern der Vertragspartner zur Begleichung von Buchungen Kreditkarten oder vergleichbare Zahlungsinstrumente einsetzt, trägt er das vollständige
                     wirtschaftliche und rechtliche Risiko sämtlicher hieraus resultierender Rückbelastungen (Chargebacks), unabhängig davon, ob es sich um eigene Firmenkreditkarten oder um
                     Kreditkarten von Endkunden handelt. Der Vertragspartner stellt GTS von sämtlichen hieraus entstehenden Belastungen, Gebühren, Vertragsstrafen und sonstigen Kosten vollständig
                     frei.
                  </p>
                  <p>
                     <strong>8.5</strong> Rückbelastungen, Einwendungen von Karteninhabern, Zahlungsdienstleistern oder Kreditkarteninstituten sowie daraus resultierende Sperrungen, Verzögerungen oder
                     Kosten berühren die Zahlungspflicht des Vertragspartners gegenüber GTS nicht. Die Zahlungspflicht bleibt auch im Falle eines Chargebacks uneingeschränkt bestehen. Ein
                     Zurückbehaltungs- oder Leistungsverweigerungsrecht steht dem Vertragspartner insoweit nicht zu.
                  </p>
                  <p>
                     <strong>8.6</strong> Soweit Endkunden zur Begleichung von Buchungen Kreditkarten oder sonstige Zahlungsinstrumente einsetzen, erfolgt die Zahlungsabwicklung ausschließlich im
                     Namen und für Rechnung des jeweiligen Vertragspartners. GTS tritt hierbei lediglich als technischer Zahlungsdienstleister bzw. Inkassostelle auf. Eine Entgegennahme von Zahlungen
                     des Endkunden im eigenen Namen durch GTS erfolgt nicht.
                  </p>

                  <h3 id="stornierung">9 Stornierungen, Umbuchungen und Nichtinanspruchnahme</h3>
                  <p>
                     <strong>9.1</strong> Stornierungen, Umbuchungen oder sonstige Änderungen sind ausschließlich nach Maßgabe der Geschäfts- und Vertragsbedingungen des jeweiligen Leistungsträgers
                     zulässig. GTS hat keinen Einfluss auf Art, Umfang oder Höhe anfallender Gebühren.
                  </p>
                  <p>
                     <strong>9.2</strong> Stornierungs-, Umbuchungs- oder Änderungsgebühren sind vom Vertragspartner zu tragen und an GTS zu erstatten, soweit GTS oder der Leistungsträger hierdurch
                     belastet werden.
                  </p>
                  <p><strong>9.3</strong> Der Vertragspartner ist verpflichtet, Endkunden über Stornierungen oder Leistungsänderungen unverzüglich zu informieren.</p>
                  <p>
                     <strong>9.4</strong> Hat GTS Entgelte gegenüber Leistungsträgern oder Abrechnungsstellen bereits ganz oder teilweise beglichen und kommt der Vertragspartner seinen
                     Zahlungspflichten nicht oder nicht rechtzeitig nach, ist GTS berechtigt, Buchungen rückgängig zu machen, zu stornieren oder hierdurch entstandene Schäden gegenüber dem
                     Vertragspartner geltend zu machen, soweit dies rechtlich und technisch möglich ist.
                  </p>

                  <h3 id="pflichten">10 Pflichten des Vertragspartners</h3>
                  <p>
                     <strong>10.1</strong> Der Vertragspartner erfüllt sämtliche gesetzlichen Informations-, Aufklärungs- und Dokumentationspflichten gegenüber Endkunden eigenverantwortlich,
                     insbesondere nach reiserechtlichen, verbraucherschutzrechtlichen und luftverkehrsrechtlichen Vorschriften.
                  </p>
                  <p>
                     <strong>10.2</strong> Der Vertragspartner stellt sicher, dass Buchungsunterlagen, Tickets oder sonstige Leistungsdokumente erst nach vollständiger Zahlung an Endkunden
                     herausgegeben werden.
                  </p>
                  <p><strong>10.3</strong> Der Vertragspartner haftet für Pflichtverletzungen seiner Mitarbeiter und Erfüllungsgehilfen wie für eigenes Verschulden.</p>
                  <p>
                     <strong>10.4</strong> Der Vertragspartner ist verpflichtet, gegenüber Endkunden zutreffende, vollständige und nicht irreführende Angaben zu den vermittelten Reiseleistungen zu
                     machen und sicherzustellen, dass die Darstellung der Leistungen den von GTS übermittelten Informationen entspricht.
                  </p>

                  <h3 id="reklamation">11 Reklamationen und Mängelanzeigen</h3>
                  <p>
                     <strong>11.1</strong> Reklamationen des Endkunden, die die Durchführung oder Qualität der Reiseleistung betreffen, sind ausschließlich gegenüber dem jeweiligen Leistungsträger
                     geltend zu machen.
                  </p>
                  <p>
                     <strong>11.2</strong> Mängel der reinen Vermittlungs- oder technischen Leistung von GTS sind vom Vertragspartner unverzüglich, spätestens innerhalb von sieben Kalendertagen nach
                     Kenntniserlangung, anzuzeigen.
                  </p>
                  <p><strong>11.3</strong> Unterlässt der Vertragspartner eine rechtzeitige Anzeige, sind hieraus resultierende Ansprüche ausgeschlossen, soweit gesetzlich zulässig.</p>

                  <h3 id="haftung">12 Haftung von GTS</h3>
                  <p><strong>12.1</strong> GTS haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit.</p>
                  <p><strong>12.2</strong> Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt.</p>
                  <p><strong>12.3</strong> Im Übrigen ist die Haftung ausgeschlossen, soweit gesetzlich zulässig.</p>
                  <p><strong>12.4</strong> Eine Haftung von GTS für Leistungen, Angaben, Inhalte oder Verfügbarkeiten der jeweiligen Leistungsträger ist ausgeschlossen.</p>

                  <h3 id="datenschutz">13 Datenschutz und Vertraulichkeit</h3>
                  <p><strong>13.1</strong> GTS verarbeitet personenbezogene Daten im Einklang mit den geltenden Datenschutzgesetzen und der Datenschutzerklärung von GTS.</p>
                  <p>
                     <strong>13.2</strong> Beide Parteien verpflichten sich, nicht öffentliche, vertrauliche oder geschäftliche Informationen, die ihnen im Rahmen der Zusammenarbeit bekannt werden,
                     vertraulich zu behandeln und nicht an unbefugte Dritte weiterzugeben.
                  </p>
                  <p><strong>13.3</strong> Diese Verpflichtung gilt auch über die Beendigung des Vertragsverhältnisses hinaus.</p>

                  <h3 id="aufrechnung">14 Aufrechnung und Zurückbehaltungsrechte</h3>
                  <p><strong>14.1</strong> Eine Aufrechnung oder die Geltendmachung von Zurückbehaltungsrechten ist nur mit unbestrittenen oder rechtskräftig festgestellten Forderungen zulässig.</p>

                  <h3 id="kuendigung">15 Vertragslaufzeit und Kündigung</h3>
                  <p><strong>15.1</strong> Der Vertrag wird auf unbestimmte Zeit geschlossen und kann von jeder Partei mit einer Frist von vier Wochen zum Monatsende ordentlich gekündigt werden.</p>
                  <p>
                     <strong>15.2</strong> Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt. Ein wichtiger Grund liegt insbesondere bei erheblichen Zahlungsrückständen oder
                     schwerwiegenden Verstößen gegen diese AGB vor.
                  </p>

                  <h3 id="aenderungen">16 Änderungen der AGB</h3>
                  <p>
                     <strong>16.1</strong> Änderungen dieser AGB werden dem Vertragspartner in Textform mitgeteilt und gelten als genehmigt, sofern der Vertragspartner nicht innerhalb von vier Wochen
                     nach Zugang widerspricht.
                  </p>
                  <p><strong>16.2</strong> Im Falle eines fristgerechten Widerspruchs ist GTS berechtigt, das Vertragsverhältnis ordentlich zu kündigen.</p>

                  <h3 id="schluss">17 Schlussbestimmungen</h3>
                  <p>
                     <strong>17.1</strong> Es gilt deutsches Recht. Gerichtsstand ist Hamburg. Vertragssprache ist Deutsch. Änderungen und Ergänzungen dieser AGB bedürfen der Textform. Dies gilt auch
                     für die Aufhebung dieses Textformerfordernisses.
                  </p>

                  <p style="margin-top: 48px; text-align: left; color: #717171; font-size: 14px">Stand Januar 2026</p>
               </section>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
// import * as RestApi from "@/service/rest.api";
// import InlineSvg from "vue-inline-svg";
export default {
   name: "DatenschutzPage",
   components: {
      // InlineSvg,
   },
   data() {
      return {
         activeSection: "geltungsbereich",
         hasReachedTop: false,
         sections: [
            { id: "geltungsbereich", label: "1. Geltungsbereich", read: false },
            { id: "begriffe", label: "2. Begriffe", read: false },
            { id: "vertragsgegenstand", label: "3. Vertragsgegenstand", read: false },
            { id: "rolle", label: "4. Rolle von GTS", read: false },
            { id: "nutzung", label: "5. Nutzung der Plattform", read: false },
            { id: "api", label: "6. API-, IBE- und White-Label", read: false },
            { id: "buchung", label: "7. Buchungsablauf", read: false },
            { id: "zahlung", label: "8. Zahlungsabwicklung", read: false },
            { id: "stornierung", label: "9. Stornierungen", read: false },
            { id: "pflichten", label: "10. Pflichten des Vertragspartners", read: false },
            { id: "reklamation", label: "11. Reklamationen", read: false },
            { id: "haftung", label: "12. Haftung von GTS", read: false },
            { id: "datenschutz", label: "13. Datenschutz", read: false },
            { id: "aufrechnung", label: "14. Aufrechnung", read: false },
            { id: "kuendigung", label: "15. Kündigung", read: false },
            { id: "aenderungen", label: "16. Änderungen der AGB", read: false },
            { id: "schluss", label: "17. Schlussbestimmungen", read: false },
         ],
      };
   },
   mounted() {
      this.hasReachedTop = false;

      // 🧠 sayfa zaten en üstteyse manuel reset
      if (window.scrollY === 0) {
         this.sections.forEach((s) => (s.read = false));
         this.hasReachedTop = true;
      }

      window.addEventListener("scroll", this.onScroll);
   },

   beforeUnmount() {
      window.removeEventListener("scroll", this.onScroll);
   },
   methods: {
      scrollToSection(id) {
         const element = document.getElementById(id);
         if (element) {
            const offset = 120;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
               top: offsetPosition,
               behavior: "smooth",
            });
         }
      },
      onScroll() {
         // 🧼 ilk kez en üste gelince reset
         if (window.scrollY === 0 && !this.hasReachedTop) {
            this.sections.forEach((s) => (s.read = false));
            this.hasReachedTop = true;
            return; // ⛔ reset sırasında read işleme
         }

         if (!this.hasReachedTop) return; // henüz tepede değilsek ignore

         const pos = window.scrollY + window.innerHeight * 0.5;

         for (let i = this.sections.length - 1; i >= 0; i--) {
            const s = this.sections[i];
            const el = document.getElementById(s.id);

            if (el && el.offsetTop <= pos) {
               this.activeSection = s.id;
               if (!s.read) s.read = true;
               break;
            }
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.alreadyRead {
   color: #a1a1a1 !important;
   // color: #33b8ff !important;
}
.tick-icon {
   display: inline-block;
   width: 20px;
   height: 20px;
}

.hidden {
   visibility: hidden; /* 👈 yer korunur */
}

#static-page-wrapper {
   padding: 50px 24px 80px;
   min-height: 100vh;

   @media (max-width: 1024px) {
      padding: 100px 24px 64px;
   }

   .container {
      // max-width: 1440px;
      margin: 0 auto;
   }

   #page-header {
      margin: 0 0 48px;
      padding: 32px 48px;
      background: #fafafa;
      border-radius: 12px;

      .page-title {
         font-size: 32px;
         font-weight: 600;
         color: #222222;
         margin: 0;
         line-height: 1.25;

         @media (min-width: 768px) {
            font-size: 48px;
         }
      }
   }

   .content-wrapper {
      display: grid;
      grid-template-columns: 260px 1fr;
      gap: 64px;

      @media (max-width: 1024px) {
         grid-template-columns: 1fr;
         gap: 32px;
      }

      @media (max-width: 768px) {
         grid-template-columns: 1fr;
         gap: 0;
      }
   }

   .sidebar-menu {
      padding: 24px 0;

      @media (max-width: 1024px) {
         width: 100%;
         border-bottom: 1px solid #e5e5e5;
         padding-bottom: 24px;
      }

      @media (max-width: 768px) {
         display: none;
      }

      .sticky-nav {
         position: sticky;
         top: 116px;
         display: flex;
         flex-direction: column;
         gap: 4px;

         @media (max-width: 1024px) {
            position: static;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 8px;
         }

         .nav-item {
            padding: 8px 12px;
            font-size: 15px;
            color: #717171;
            text-decoration: none;
            border-radius: 8px;
            transition: all 0.2s ease;
            font-weight: 500;
            min-height: 38px;
            align-items: center;
            display: flex;
            gap: 0.25rem;

            &:hover {
               background: #f7f7f7;
               color: #222222;
            }

            &.active {
               background: #e1e1e1;
               background: #2f64b9;
               color: #222222;
               color: #fff !important;
               // font-weight: 600;
            }

            @media (max-width: 1024px) {
               padding: 6px 12px;
               font-size: 14px;
            }
         }
      }
   }

   .page-content {
      flex: 1;
      min-width: 0;
      border-left: 1px solid #e5e5e5;
      padding-left: 64px;

      @media (max-width: 1024px) {
         border-left: none;
         padding-left: 0;
      }

      @media (max-width: 768px) {
         width: 100%;
         padding-left: 0;
         border-left: none;
      }

      .privacy-section {
         margin-bottom: 48px;

         &:last-child {
            margin-bottom: 0;
         }

         h2 {
            font-size: 24px;
            font-weight: 600;
            color: #222222;
            margin: 0 0 24px 0;
            line-height: 1.3;
            padding: 10px 1rem;
            background: #fafafa;
            border-radius: 8px;
            margin-left: -1rem;

            @media (min-width: 768px) {
               font-size: 28px;
            }
         }

         h3 {
            font-size: 19px;
            font-weight: 600;
            color: #222222;
            margin: 32px 0 16px;
            line-height: 1.4;
            padding: 0.125rem 1rem;
            background: #f6f6f6;
            background: #2f64b909;
            // color: #fff;
            // color: #2f64b9;
            border-radius: 8px;
            margin-left: -1rem;
            margin-top: 3rem;

            &:first-of-type {
               margin-top: 0;
            }

            @media (min-width: 768px) {
               font-size: 22px;
            }
         }

         h4 {
            font-size: 17px;
            font-weight: 600;
            color: #222222;
            // color: #2f64b9;

            margin: 24px 0 12px;

            line-height: 1.4;

            &:first-of-type {
               margin-top: 0;
            }

            @media (min-width: 768px) {
               font-size: 18px;
            }
         }

         p {
            color: #222222;
            // color: #6a6a6a;
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 16px;
            font-weight: 400;

            &:last-child {
               margin-bottom: 0;
            }

            a {
               color: #2f64b9;
               text-decoration: underline;

               &:hover {
                  color: #000000;
               }
            }
         }

         ul {
            color: #222222;
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 16px;
            padding-left: 24px;
            list-style: none;
            counter-reset: list-counter;

            li {
               margin-bottom: 8px;
               counter-increment: list-counter;
               position: relative;
               padding-left: 8px;

               &:before {
                  content: "(" counter(list-counter) ")";
                  position: absolute;
                  left: -24px;
                  color: #717171;
               }

               &:last-child {
                  margin-bottom: 0;
               }
            }
         }
      }
   }
}
</style>
